/* eslint-disable */
import { scrollService } from './../service/ScrollService'
class NavListener {

	setProducts(products) {
		this.products = products
		products.forEach(product => this.addListener(product))
	}
	
	addListener (product) {
		product.nav.addEventListener('click', this.execute.bind(this, product))
	}

	execute(product){
		scrollService.scrollTo(product)
	}
}

const navListener = new NavListener()
export { NavListener, navListener }
